const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');

class PayyoDeviceRequestRecord extends AbstractPayyoRequestRecord {
    /**
     * A 35 character string beginning with dv_ which identifies a device (terminal) in Payyo.
     * In production this will always be a physical device but virtual (simulated) devices can exist in development.
     *
     * @param {string} deviceId
     */
    constructor(deviceId) {
        const regex = /^dv_[a-zA-Z0-9]{32}$/g;
        if (!deviceId || !deviceId.match(regex)) {
            throw new Error('A valid deviceId is required');
        }
        super(
            'GET',
            'devices/' + deviceId,
        );
    }
}

module.exports = PayyoDeviceRequestRecord;
